import React, { useEffect, useState } from "react";
import Summary from "../components/Summary";
import Select from "react-select";
import ToggleTable from "../components/Tables/Fleet/ToggleTable";
import BottomToggleTable from "../components/Tables/Fleet/BottomToggleTable";
import WeeklyDatePicker from "../../payments/paymentsComponents/WeeklyDatePicker";
import {
  DownArrow,
  ToggleIcon,
  DropdownToggleIcon,
} from "../components/helpers/svgHelper";

function Fleet({
  data,
  fleets,
  companies,
  comparisonOptions,
  loading,
  handleChange,
  selectedFleet,
  setSelectedFleet,
  defaultSelectedFleet,
  selectedCompanies,
  setSelectedCompanies,
  fetchFleetOverview,
  selectedOption,
  setSelectedOption,
  selectStyles,
  multiSelectStyles,
  fleetTrips,
  fleetTotals,
  week,
  setWeek,
  // downloadPdf
  downloadFleetStatement,
}) {
  const [tabView, setTabView] = useState(true);
  const [dropdown, setDropdown] = useState(false);
  const [isButtonDropdownOpen, setIsButtonDropdownOpen] = useState(false);

  useEffect(() => {
    resetFilters();
  }, []);

  const fleetsSelect = () => {
    const formatedFleets = fleets.map((fleet) => {
      return { label: fleet.name, value: fleet.id };
    });
    return formatedFleets;
  };

  useEffect(() => {
    const allCompanies = companiesSelect();
    if (allCompanies.length > 0 && selectedCompanies.length === 0) {
      setSelectedCompanies(allCompanies);
    }
  }, [companiesSelect]);

  const onChangedSelectedFleet = (fleetSelected) => {
    setSelectedFleet(fleetSelected);
  };

  const companiesSelect = () => {
    const formatedCompanies = companies.map((company) => {
      return { label: company.name, value: company.id };
    });
    return formatedCompanies;
  };

  const allCompaniesOption = {
    label: "All",
    value: "all",
    companies: companiesSelect(),
  };

  const onChangedSelectedCompanies = (selected) => {
    if (!selected) return;

    if (
      Array.isArray(selected) &&
      selected.find((opt) => opt.value === "all")
    ) {
      // If "All" is selected, set all companies
      setSelectedCompanies(companiesSelect());
    } else {
      // Otherwise, set selected individual companies
      setSelectedCompanies(selected);
    }
  };

  const toggleDropdown = () => {
    setIsButtonDropdownOpen(!isButtonDropdownOpen);
  };

  const resetFilters = () => {
    setSelectedFleet(defaultSelectedFleet ?? null);
    setSelectedCompanies([]);
    setSelectedOption(null);
  };

  return (
    <div className="bg-transparent pt-2 pb-4 space-y-4">
      {loading && (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-50 flex flex-col items-center justify-center">
          <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
        </div>
      )}
      <div className="flex flex-row justify-between">
        <div className="flex flex-row w-11/12 space-x-2">
          <div className="w-2/5" style={{ height: "45px" }}>
            <Select
              value={selectedFleet}
              onChange={onChangedSelectedFleet}
              options={fleetsSelect()}
              placeholder="Fleet"
              styles={selectStyles}
            />
          </div>
          <div className="w-2/5" style={{ height: "40px" }}>
            <Select
              isMulti
              name="companies"
              options={[allCompaniesOption]}
              onChange={onChangedSelectedCompanies}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={"Company"}
              closeMenuOnSelect={false}
              value={[allCompaniesOption]}
              styles={{
                ...multiSelectStyles,
                control: (base, state) => {
                  const inherited = typeof multiSelectStyles?.control === "function"
                    ? multiSelectStyles.control(base, state)
                    : base;
                  return { ...inherited, minHeight: 40, height: 40 };
                },
              }}
            />
          </div>
          <div className="relative inline-block text-left">
            <div>
              <button
                type="button"
                style={{ width: "150px" }}
                onClick={() => setDropdown(!dropdown)}
                className="inline-flex w-full justify-between gap-x-1.5 border-gray-400 border rounded-md bg-white text-gray-400 px-3 py-2 text-xxs font-thin shadow-sm"
              >
                {week.from} - {week.to}
                <DownArrow />
              </button>
            </div>
            {dropdown && (
              <WeeklyDatePicker
                setWeek={setWeek}
                week={week}
                dropdown={dropdown}
                setDropdown={setDropdown}
              />
            )}
          </div>
          <Select
            value={selectedOption}
            onChange={(option) => handleChange(option)}
            options={comparisonOptions}
            placeholder="Comparison Period"
            styles={selectStyles}
          />
          <div className="flex space-x-2">
            <button
              disabled={selectedOption === null}
              onClick={fetchFleetOverview}
              style={{ height: "40px" }}
              className={
                selectedOption === null
                  ? "bg-gray-400 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
                  : "bg-purple-600 text-white font-normal text-sm py-1 px-4 rounded-lg"
              }
            >
              Apply Filters
            </button>

            <button
              onClick={() => resetFilters()}
              style={{ height: "40px" }}
              className="border border-gray-300 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
            >
              Reset Filters
            </button>
          </div>
        </div>

        <div className="flex flex-row">
          <button
            disabled={true}
            onClick={() => setTabView(!tabView)}
            className="w-8 h-8 bg-gray-400 hover:bg-gray-700 rounded-md shadow-xl flex items-center justify-center transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75"
          >
            <ToggleIcon />
          </button>
        </div>
      </div>

      {data.total_trips > 0 && (
        <>
          <div className="flex flex-row justify-between space-x-4">
            <div className="w-1/3 px-2 flex flex-row items-center space-x-2">
              {data.fleets_account_data[0]?.fleet_name} Week{" "}
              {data.current_week_start}
            </div>
            <div className="relative inline-block text-left">
              <div>
                <button
                  type="button"
                  className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-1 py-1 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                  id="menu-button"
                  aria-expanded={isButtonDropdownOpen}
                  aria-haspopup="true"
                  onClick={toggleDropdown}
                >
                  <DropdownToggleIcon />
                </button>
              </div>
              {isButtonDropdownOpen && (
                <div
                  className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabIndex="-1"
                >
                  <div className="py-1" role="none">
                    <button
                      className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                      onClick={() => downloadFleetStatement(1)}
                    >
                      Download Statement {data.current_week_start}
                    </button>
                    <button
                      className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                      onClick={() => downloadFleetStatement(2)}
                    >
                      Download Statement {data.previous_week_start}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-row space-x-4">
            <div className="w-1/3">
              <Summary title="Trip Breakdown" breakdown={fleetTrips} />
            </div>
            <div className="w-1/3">
              <Summary title="Payout" breakdown={fleetTotals} />
            </div>
          </div>

          <div
            className="overflow-y-auto overflow-x-auto px-2 scrollbar mb-10"
            style={{ maxHeight: "800px" }}
          >
            <ToggleTable data={data.toggle_data} />
          </div>

          <div
            className="overflow-y-auto overflow-x-auto px-2 scrollbar mt-4"
            style={{ maxHeight: "800px" }}
          >
            <BottomToggleTable
              data={data.bottom_toggle}
              selectStyles={selectStyles}
              current_week={data.current_week_start}
              previous_week={data.previous_week_start}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Fleet;
